import { render, staticRenderFns } from "./ButtonFormat.vue?vue&type=template&id=11cad11a&scoped=true&"
import script from "./ButtonFormat.vue?vue&type=script&lang=js&"
export * from "./ButtonFormat.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFormat.vue?vue&type=style&index=0&id=11cad11a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cad11a",
  null
  
)

export default component.exports